import React, { useState, useEffect, useRef } from 'react';
import {
  FilterList as FilterIcon,
  Clear as ClearIcon,
} from '@material-ui/icons';
import styles from './CategoryFilter.module.css';

const CategoryFilter = ({
  categories = [],
  selectedCategory,
  onCategorySelect,
  loading = false,
  onFetchCategories,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const handleToggleDropdown = () => {
    if (!isOpen && categories.length === 0) {
      // Fetch categories if not already loaded
      onFetchCategories?.();
    }
    setIsOpen(!isOpen);
  };

  const handleCategorySelect = (category) => {
    onCategorySelect(category);
    setIsOpen(false);
  };

  const handleClearFilter = (e) => {
    e.stopPropagation();
    onCategorySelect(null);
  };

  return (
    <div className={styles.categoryFilter} ref={dropdownRef}>
      <button
        className={`${styles.filterButton} ${
          selectedCategory ? styles.active : ''
        }`}
        onClick={handleToggleDropdown}
        disabled={loading}
      >
        <FilterIcon className={styles.filterIcon} />
        <span className={styles.filterText}>
          {selectedCategory ? selectedCategory.name : 'Filter by Category'}
        </span>
        {selectedCategory && (
          <ClearIcon className={styles.clearIcon} onClick={handleClearFilter} />
        )}
      </button>

      {isOpen && (
        <div className={styles.dropdown}>
          <div className={styles.dropdownHeader}>
            <span>Select Category</span>
          </div>
          <div className={styles.dropdownList}>
            {loading ? (
              <div className={styles.loadingItem}>Loading categories...</div>
            ) : categories.length === 0 ? (
              <div className={styles.emptyItem}>No categories found</div>
            ) : (
              <>
                <div
                  role="button"
                  tabIndex={0}
                  className={`${styles.dropdownItem} ${
                    !selectedCategory ? styles.selected : ''
                  }`}
                  onClick={() => handleCategorySelect(null)}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter' || e.key === ' ') {
                      handleCategorySelect(null);
                    }
                  }}
                >
                  All Categories
                </div>
                {categories.map((category) => (
                  <div
                    key={category.value}
                    role="button"
                    tabIndex={0}
                    className={`${styles.dropdownItem} ${
                      selectedCategory?.value === category.value
                        ? styles.selected
                        : ''
                    }`}
                    onClick={() => handleCategorySelect(category)}
                    onKeyDown={(e) => {
                      if (e.key === 'Enter' || e.key === ' ') {
                        handleCategorySelect(category);
                      }
                    }}
                  >
                    {category.name}
                  </div>
                ))}
              </>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default CategoryFilter;
